import React from 'react';
import { Collapse } from 'reactstrap';
import Card from 'react-bootstrap/Card';
import RoleEvents from '../components/eventsLi';
import { faAngleRight, faAngleDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default class ListGroupCollapse extends React.Component {
    constructor(props) {
        super(props);

        this.toggle = this.toggle.bind(this);
        this.state = { collapse: true };
    }

    toggle() {
        this.setState({ collapse: !this.state.collapse });
    }

    render() {
        let self = this;
        const { Role, Events } = self.props.item;
        let {executeEvent, isDisable, isDeadLinePassed, showModal, isMultiSimulationAllow, isSelectedRole} = self.props;
        if ((Role === '' || Role === 'unassigned') && Events.length === 0) {
            return null;
        }
        return (
            <div>
                <Card>
                    <Card.Header onClick={self.toggle}
                        aria-expanded={self.state.collapse}
                    >
                        <FontAwesomeIcon className='collapseArrow' icon={(Events != null ? (Events.length > 0 ? self.state.collapse : false) : false) ? faAngleRight : faAngleDown} /> {Role === undefined ? '' : (Role === '' ? 'Unassigned' : Role)}
                    </Card.Header>
                    <Collapse isOpen={Events != null ? (Events.length > 0 ? self.state.collapse : false) : false} >
                        <Card.Body>
                            <RoleEvents
                                events={Events}
                                onClick={executeEvent}
                                isDisable={isDisable}
                                isDeadLinePassed={isDeadLinePassed}
                                showModal={showModal}
                                role={Role === undefined ? '' : Role}
                                isMultiSimulationAllow={isMultiSimulationAllow}
                                isSelectedRole={isSelectedRole}
                            />
                        </Card.Body>
                    </Collapse>
                </Card>
            </div>
        )
    }
}